import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=74907365&"
import script from "./CCheckbox.vue?vue&type=script&lang=js&"
export * from "./CCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports